import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-request-call-confirmation-dialog',
  templateUrl: './request-call-confirmation-dialog.component.html',
  styleUrls: ['./request-call-confirmation-dialog.component.scss']
})
export class RequestCallConfirmationDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
